var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-component",class:[`app-${_vm.$route.name}`, { 'app-headBorder': _vm.scrollHeight > 0 }],attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }